import { takeEvery } from 'redux-saga/effects';

import { resourceSagaUtils, resourceStoreTypes } from '../core';

import * as actions from './accountsBalancesActions';
import { getLastSyncDate } from './accountsBalancesSelectors';
import { mkAccountsBalance } from './accountsBalancesTypes';

const mkConfig = (props) =>
  resourceStoreTypes.mkQcsSyncResourceConfig({
    resourceName: 'accounts balances',
    resourceBaseUrl: '/accounts/balances',
    getLastSyncDate: getLastSyncDate,
    transformResponseToResources: (response) =>
      response.data && response.data.resources && response.data.resources.map((data) => mkAccountsBalance(data)),
    ...props,
  });

export function* getAccountsBalancesActionWatcher() {
  yield resourceSagaUtils.takeAndDebounce(
    actions.getAccountsBalances,
    resourceSagaUtils.qcsSyncGetResources,
    mkConfig({
      successAction: actions.getAccountsBalancesSuccess,
      failureAction: actions.getAccountsBalancesFailure,
    }),
  );
}

export function* batchAccountsBalancesActionWatcher() {
  yield takeEvery(
    actions.batchAccountsBalances,
    resourceSagaUtils.qcsSyncUpdateResources,
    mkConfig({
      successAction: actions.batchAccountsBalancesSuccess,
      failureAction: actions.batchAccountsBalancesFailure,
    }),
  );
}

export default [getAccountsBalancesActionWatcher, batchAccountsBalancesActionWatcher];
